import { css } from 'emotion'
export const InlineStyleButtonStyles = css``
